/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type PrintReceiptRequest,
    PrintReceiptRequestFromJSON,
    PrintReceiptRequestToJSON,
} from '../models/PrintReceiptRequest';
import {
    type PrintTerminalRequest,
    PrintTerminalRequestFromJSON,
    PrintTerminalRequestToJSON,
} from '../models/PrintTerminalRequest';
import {
    type PrintTextRequest,
    PrintTextRequestFromJSON,
    PrintTextRequestToJSON,
} from '../models/PrintTextRequest';
import {
    type PrintTextResponse,
    PrintTextResponseFromJSON,
    PrintTextResponseToJSON,
} from '../models/PrintTextResponse';

export interface PrintRequest {
    printTerminalRequest: PrintTerminalRequest;
}

export interface PrintReceiptOperationRequest {
    printReceiptRequest: PrintReceiptRequest;
}

export interface PrintTextOperationRequest {
    printTextRequest: PrintTextRequest;
}

/**
 * 
 */
export class AdyenTerminalPrintControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for print without sending the request
     */
    async printRequestOpts(requestParameters: PrintRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['printTerminalRequest'] == null) {
            throw new runtime.RequiredError(
                'printTerminalRequest',
                'Required parameter "printTerminalRequest" was null or undefined when calling print().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v3/inhouse/terminal/print`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrintTerminalRequestToJSON(requestParameters['printTerminalRequest']),
        };
    }

    /**
     */
    async printRaw(requestParameters: PrintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrintTextResponse>> {
        const requestOptions = await this.printRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrintTextResponseFromJSON(jsonValue));
    }

    /**
     */
    async print(requestParameters: PrintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrintTextResponse> {
        const response = await this.printRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for printReceipt without sending the request
     */
    async printReceiptRequestOpts(requestParameters: PrintReceiptOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['printReceiptRequest'] == null) {
            throw new runtime.RequiredError(
                'printReceiptRequest',
                'Required parameter "printReceiptRequest" was null or undefined when calling printReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v3/inhouse/terminal/print-receipt`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrintReceiptRequestToJSON(requestParameters['printReceiptRequest']),
        };
    }

    /**
     */
    async printReceiptRaw(requestParameters: PrintReceiptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrintTextResponse>> {
        const requestOptions = await this.printReceiptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrintTextResponseFromJSON(jsonValue));
    }

    /**
     */
    async printReceipt(requestParameters: PrintReceiptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrintTextResponse> {
        const response = await this.printReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for printText without sending the request
     */
    async printTextRequestOpts(requestParameters: PrintTextOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['printTextRequest'] == null) {
            throw new runtime.RequiredError(
                'printTextRequest',
                'Required parameter "printTextRequest" was null or undefined when calling printText().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v3/inhouse/terminal/print-text`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrintTextRequestToJSON(requestParameters['printTextRequest']),
        };
    }

    /**
     */
    async printTextRaw(requestParameters: PrintTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrintTextResponse>> {
        const requestOptions = await this.printTextRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrintTextResponseFromJSON(jsonValue));
    }

    /**
     */
    async printText(requestParameters: PrintTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrintTextResponse> {
        const response = await this.printTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
